import React from 'react'
import { teamTwoData } from '../data/data'
import { Link } from 'react-router-dom'

export default function TeamTwo() {
  return (
    <>
    <div className="row">
        {teamTwoData.map((item,index)=>{
            return(
                <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="team text-center rounded p-3 py-4">
                        <img src={item.image} className="img-fluid avatar avatar-medium shadow rounded-pill" alt=""/>
                        <div className="content mt-3">
                            <h4 className="title mb-0">{item.name}</h4>
                            <small className="text-muted">{item.position}</small>
                            <ul className="list-unstyled mt-3 social-icon social mb-0">
                                {item.social.map((el,index)=>{
                                    return(
                                        <li className="list-inline-item m-x-2" key={index}><Link href="#" className="rounded"><i className={el}></i></Link></li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            )
        })}
    </div> 
    </>
  )
}
